import { LitElement, html, css, unsafeCSS, nothing } from 'lit';
import COUNTRIES_DATA from '@/data/countries.json';
import { getMessage } from '@/localization.js';
import messages from './localization.json';
import styles from './style.scss?inline';

/**
 * @attribute country - ISO code of the country whose flag to display
 */
export default class SotbitFlag extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        country: {
            type: String,
            converter: {
                fromAttribute: (value) => {
                    return value.toUpperCase();
                },
            },
        },
    };

    getFlagImageSource() {
        const moduleBaseUrl = import.meta.url.replace(/ui.*$/, 'ui');

        return `${moduleBaseUrl}/assets/flags/${this.country}.svg`;
    }

    render() {
        if (!COUNTRIES_DATA[this.country]) {
            console.warn(`No data found for country with code "${this.country}"`);
            return nothing;
        }

        return html`
            <div part="flag-container">
                <img
                    part="flag"
                    loading="lazy"
                    src="${this.getFlagImageSource()}"
                    alt="${getMessage(messages, 'flag', {
                        '#COUNTRY#': COUNTRIES_DATA[this.country].name,
                    })}"
                    inert
                />
            </div>
        `;
    }
}
